import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { Symbols } from '../../symbols';
let HomepageApi = class HomepageApi {
    constructor(http, urls) {
        this.http = http;
        this.urls = urls;
    }
    setProductUpdates(params) {
        return this.http.post({
            url: this.urls.setProductUpdates,
            data: params,
        });
    }
    uploadImage(base64) {
        return this.http.post({
            url: this.urls.uploadAdImg,
            data: {
                base64,
            },
        });
    }
    setAdImageData(params) {
        return this.http.post({
            url: this.urls.setAdImage,
            data: params,
        });
    }
};
HomepageApi = __decorate([
    injectable(),
    __param(0, inject(Symbols.CoreBasicHttp)),
    __param(1, inject(Symbols.HomepageApiUrls)),
    __metadata("design:paramtypes", [Object, Object])
], HomepageApi);
export { HomepageApi };
